// extracted by mini-css-extract-plugin
export default {"shares":"index_shares_eFlS0","iframe":"index_iframe_00-66","come":"index_come_HfNx6","laiyuan":"index_laiyuan_ObpUa"};